module.exports = __webpack_public_path__ + "static/media/profile.49295e84.svg";